import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'team-management/devices';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const DEVICE_LIST_GET = createApiNamespacedConstants('DEVICE_LIST_GET');
export const ASSIGN_DEVICE_TO_TEAM = createApiNamespacedConstants('ASSIGN_DEVICE_TO_TEAM');
export const UNASSIGN_DEVICE_FROM_TEAM = createApiNamespacedConstants('UNASSIGN_DEVICE_FROM_TEAM');
export const UNASSIGN_ALL_DEVICES_FROM_TEAM = createApiNamespacedConstants('UNASSIGN_ALL_DEVICES_FROM_TEAM');
export const UPDATE_DEVICE_SETTINGS = createApiNamespacedConstants('UPDATE_DEVICE_SETTINGS');
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
